import { useTranslation } from "react-i18next";
import useStyleUtils from "../../../../utilities/styles";
import { useState } from "react";
import { Col, Row } from "react-grid-system";
import TextField from "../../textField/TextField";
import IAddAttributeFieldProps from "./IAddAttributeFieldProps";
import { Button } from "@fluentui/react-components";
import { Add16Filled } from "@fluentui/react-icons";
import IAttribute from "../../../../models/IAttribute";

export default function AddAttributeField(props: IAddAttributeFieldProps) {
    const { t } = useTranslation();

    const style = useStyleUtils();

    const [name, setName] = useState<string>("");
    const [value, setValue] = useState<string>("");

    const handleSubmit = () => {
        const attribute: IAttribute = { name, value };
        props.onAdd(attribute);

        setName("");
        setValue("");
    }

    return (
        <Row className={style.mb3} align="end">
            <Col xs={12} lg={5}>
                <TextField required
                    type="text"
                    label={t("attributes.formFields.add.name.label")}
                    onChange={(value) => setName(value)}
                    value={name}
                    placeholder={t("attributes.formFields.add.name.placeholder")}
                    />
            </Col>
            <Col xs={12} lg={5}>
                <TextField required
                    type="text"
                    label={t("attributes.formFields.add.value.label")}
                    onChange={(value) => setValue(value)}
                    value={value}
                    placeholder={t("attributes.formFields.add.value.placeholder")}
                    />
            </Col>
            <Col xs={12} lg={2}>
                <Button icon={<Add16Filled />} onClick={handleSubmit} />
            </Col>
        </Row>
    );
}